export default __webpack_public_path__ + "static/media/create-new-studio.11538f56.svg";